import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { GraduationCap } from 'lucide-react';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace('#', ''));
    const sessionId = params.get('session_id');
    if (!sessionId) { navigate('/login', { replace: true }); return; }
    api.post('/auth/session', { session_id: sessionId })
      .then((r) => {
        setUser(r.data.user);
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      })
      .catch((e) => setError(e.response?.data?.detail || 'Sign-in failed. Please try again.'));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-navy p-6 text-white">
      <span className="flex h-12 w-12 animate-pulse items-center justify-center rounded-xl bg-gold text-navy"><GraduationCap size={26} /></span>
      {!error ? (
        <p className="mt-4 text-sm text-white/70">Signing you in…</p>
      ) : (
        <div data-testid="auth-error" className="mt-6 max-w-md rounded-2xl border border-white/20 bg-white/10 p-6 text-center">
          <p className="text-base font-semibold text-white">{error}</p>
          <button data-testid="back-to-login" onClick={() => navigate('/login', { replace: true })}
            className="mt-4 rounded-lg bg-white px-5 py-2 text-sm font-semibold text-navy hover:bg-white/90">
            Back to Sign In
          </button>
        </div>
      )}
    </div>
  );
}
